import {
    Box,
    Flex,
    Heading,
} from "@chakra-ui/react";
import { ReportConfigsTable } from "../../components/report-configs-table/report-configs-table.comp";

export function ReportConfigsList() {

    return (
        <Box p={4}>
            <Flex>
                <Heading as={'h1'}>Report Configs</Heading>
            </Flex>
            <ReportConfigsTable />
        </Box>
    );
}
